import { render, staticRenderFns } from "./AutomaticAntecipationButton.vue?vue&type=template&id=61807ff6"
import script from "./AutomaticAntecipationButton.vue?vue&type=script&lang=js"
export * from "./AutomaticAntecipationButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports